var exports = {
  "Nr": "StreamWatchHoverCard.module__card___d2NncT",
  "Br": "StreamWatchHoverCard.module__variantCompact___d2NncT",
  "wy": "StreamWatchHoverCard.module__variantList___d2NncT",
  "VH": "StreamWatchHoverCard.module__preview___d2NncT",
  "sf": "StreamWatchHoverCard.module__previewCompact___d2NncT",
  "$8": "StreamWatchHoverCard.module__previewList___d2NncT",
  "oz": "StreamWatchHoverCard.module__previewImage___d2NncT",
  "nZ": "StreamWatchHoverCard.module__previewFallback___d2NncT",
  "SV": "StreamWatchHoverCard.module__compactButtonWrap___d2NncT",
  "Iq": "StreamWatchHoverCard.module__compactButton___d2NncT",
  "$l": "StreamWatchHoverCard.module__actionRow___d2NncT",
  "uu": "StreamWatchHoverCard.module__actionButtons___d2NncT",
  "jb": "StreamWatchHoverCard.module__listButton___d2NncT",
  "fX": "StreamWatchHoverCard.module__previewClickable___d2NncT",
  "FC": "StreamWatchHoverCard.module__previewHoverOverlay___d2NncT",
  "Mp": "StreamWatchHoverCard.module__previewHoverText___d2NncT",
  "z0": "StreamWatchHoverCard.module__protipRow___d2NncT",
  "cm": "StreamWatchHoverCard.module__protipText___d2NncT",
};

module.exports = exports;
